import { useTranslation } from 'react-i18next';

export const useIsRtl = (): boolean => {
  const { i18n } = useTranslation();
  return ['ar', 'he'].includes(i18n.language);
};
